// stores/profile.ts
import { defineStore } from "pinia";
import { ref } from "vue";
import { useCookie } from "#app";
import { type Profile } from "#shared/types";

export const useProfileStore = defineStore("profile", () => {
  const profileCookie = useCookie<Profile | null>("active_profile", {
    maxAge: 60 * 60 * 24 * 7, // 7 days
    default: () => null,
  });

  const activeProfile = ref<Profile | null>(profileCookie.value);

  const setActiveProfile = (profile: Profile | null) => {
    activeProfile.value = profile;
    profileCookie.value = profile;
  };

  const loadFromCookie = () => {
    activeProfile.value = profileCookie.value;
  };

  const clearActiveProfile = () => {
    activeProfile.value = null;
    profileCookie.value = null;
  };

  const isProfileSelected = () => {
    return activeProfile.value !== null;
  };

  return {
    activeProfile,
    setActiveProfile,
    loadFromCookie,
    clearActiveProfile,
    isProfileSelected,
  };
});
